import { render } from "./conversationReports.vue?vue&type=template&id=1fa7a6ba"
import script from "./conversationReports.vue?vue&type=script&lang=js"
export * from "./conversationReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__